(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anime-product"]) return;
  try {
    
document.addEventListener('change', (event) => {
  const radio = event.target;
  if (!radio.matches('[data-site9-product] input[name="id"]')) return;
  const root = radio.closest('[data-site9-product]');
  root.querySelector('[data-site9-current-price]').textContent = radio.dataset.site9Price;
  const was = root.querySelector('[data-site9-was]');
  const saving = root.querySelector('[data-site9-saving]');
  was.textContent = radio.dataset.site9Was;
  saving.textContent = radio.dataset.site9Saving;
  was.hidden = radio.dataset.site9Sale !== 'true';
  saving.hidden = radio.dataset.site9Sale !== 'true';
  const button = root.querySelector('[data-site9-add]');
  button.disabled = radio.dataset.site9Available !== 'true';
  root.querySelector('[data-site9-add-label]').textContent = button.disabled ? button.dataset.unavailableLabel : button.dataset.availableLabel;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', radio.value);
  window.history.replaceState({}, '', url);
});
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-site9-image]');
  if (!thumb) return;
  const root = thumb.closest('[data-site9-product]');
  const image = root.querySelector('.site9-gallery-image');
  image.removeAttribute('srcset');
  image.src = thumb.dataset.site9Image;
  image.alt = thumb.dataset.site9Alt;
  root.querySelectorAll('[data-site9-image]').forEach((button) => button.setAttribute('aria-pressed', String(button === thumb)));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anime-site-header"]) return;
  try {
    
document.addEventListener('change', (event) => { if (event.target.matches('[data-site9-country]')) event.target.form.submit(); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
